import styled from 'styled-components';
import Button from 'src/components/buttons/button';
import { text } from 'styles-js/mixins/typography';

export const Container = styled.div`
  width: 750px;
  margin: 23px auto 200px;
  @media (${({ theme }) => theme.underScreenMedium}) {
    margin: 23px auto 100px;
    width: 93%;
  }
`;

export const Counter = styled.span`
  position: absolute;
  top: 10px;
  right: 10px;
  min-width: 66px;
  text-align: right;
  color: ${({ theme }) => theme.colorGreyDark};
`;

export const TipsButtonContainer = styled.div`
  margin-top: 10px;
  border-top: ${({ theme }) => theme.greyLine};
`;

export const EditorContainer = styled.div<{ $hasErrors?: boolean }>`
  position: relative;
  border: 1px solid ${({ theme, $hasErrors }) => $hasErrors ? theme.colorError : theme.colorGreyLight};
  border-radius: 4px;
  height: auto;
  width: 100%;
  padding: 10px;
  &:focus-within {
    border-color: ${({ theme }) => theme.colorBlue};
  }
  > [contenteditable]:first-child {
    outline: none;
  }
`;

export const PostContainer = styled(EditorContainer)`
  scroll-margin-top: 60px;
  min-height: 350px;
  padding: 10px 10px 0;
  @media (${({ theme }) => theme.underScreenMedium}) {
    min-height: 200px;
  }
  > [contenteditable]:first-child {
    min-height: 300px !important; // !important needed to overwrite default editor inline styles
    @media (${({ theme }) => theme.underScreenMedium}) {
      min-height: 180px !important;
    }
  }
`;

export const SubmitButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
`;

export const SubmitButton = styled(Button)`
  margin: 0;
  width: 150px;
  @media (${({ theme }) => theme.underScreenMedium}) {
    width: 100%;
  };
`;

export const Errors = styled.div`
  ${text};
  padding-top: 5px;
  color: ${({ theme }) => theme.colorError};
  display: flex;
  flex-direction: column;
  span {
    padding: 5px 0;
  }
`;

export const StyledIconButton = styled(Button)`
  margin: 0;
  .icon {
    font-size: 22px;
    &:before {
      -webkit-font-smoothing: auto;
      -moz-osx-font-smoothing: auto;
    }
  }
`;

export const TipsButton = styled(StyledIconButton)`
  margin-top: 4px;
  .icon:before {
    vertical-align: middle;
  }
`;

export const AddButton = styled(Button)`
  margin-top: 0;
  .icon {
    font-size: 13px;
    &:before {
      vertical-align: top;
      margin-right: 4px;
    }
  }
`;
